module.exports = __webpack_public_path__ + "img/jiaoyu.79005078.png";